import alaSQL from "alasql";
import wellknown from "wellknown";
import {normalizeString, buildSQLArrayString, buildSQLFirstSelectString} from "./formatters";
import {FILE_KEYS, FEATURED_REGIONS, VIEWS} from "./consts";

export function getAlaSQLPromise(config) {
  const parser = config.parser === 'csv' ? `CSV("${config.file}")` : `TXT("${config.file}")`;
  return alaSQL.promise(`SELECT * FROM ${parser}`)
}

function getPropertiesNUTS3Object(d, view){
  const t = {...d};
  delete t.geometry;
  delete t.centroid_x;
  delete t.centroid_y;
  switch (view) {
    case 'cluster':
      return {
        id: t.id,
        name: t.name,
        cluster_id: t.cluster_id,
        metro_name: t.metro_name,
        cluster_name: t.cluster_name,
        urban_name: t.urban_name,
        country_name: t.country_name
      };
    case 'occupations':
      return t;
    case 'europe':
      return t;
    default:
      return t;
  };
}

export function hydrateLoadedData(state) {
  let hydrated = false;
  let hydratedQuery;

  //NUTS3
  if (
    state.data.toJoin.nuts3 &&
    state.data.toJoin.nuts3_present &&
    state.data.dimensions.clusters &&
    state.data.dimensions.urbans &&
    state.data.dimensions.metro_stats &&
    state.data.dimensions.countries) {

    hydrated = true;
    hydratedQuery = alaSQL(`
            WITH clustersJoin as (SELECT cluster_id,cluster_name from ?)
            SELECT * FROM ? as nuts3
            LEFT JOIN clustersJoin AS clusters ON nuts3.cluster_id = clusters.cluster_id
            LEFT JOIN ? AS urbans ON nuts3.urban_id = urbans.urban_id
            LEFT JOIN ? AS countries ON nuts3.country_id = countries.country_id
            LEFT JOIN ? AS metro_stats ON nuts3.metro_id = metro_stats.metro_id
            LEFT JOIN ? AS nuts3_present ON nuts3.id = nuts3_present.nuts3_id
            `,
      [
        state.data.dimensions.clusters,
        state.data.toJoin.nuts3,
        state.data.dimensions.urbans,
        state.data.dimensions.countries,
        state.data.dimensions.metro_stats,
        state.data.toJoin.nuts3_present
      ]);

    hydratedQuery = hydratedQuery.filter(it => it.metro_name!==0);

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'nuts3': hydratedQuery
    }

    //Empty geoJSON shapes
    const geojsonShapes = {
      name: "NUTS3-shapes",
      type: "FeatureCollection",
      features: []
    };

    // Fill geoJSON files
    let geometry, properties;
    hydratedQuery.forEach(d => {
      //Parse shape
      try {
        if (d.geometry) {
          geometry = wellknown.parse(d.geometry);
        } else {
          geometry = false;
        }
      } catch (error) {
        console.error('ERROR wellknown.parse', error);
      }

      //Copy & remove geo properties
      properties = getPropertiesNUTS3Object(d,'cluster');

      //Fill shapes geojson
      geojsonShapes.features.push({
        type: "Feature",
        geometry,
        properties
      });

    });

    //Add to geojsons options
    state.map.geojsonOptions[VIEWS.REGIONAL_CLUSTER] = geojsonShapes;

    //Remove from toJoin
    delete state.data.toJoin.nuts3;
    delete state.data.toJoin.nuts3_present;
  }


  //Employment_data
  if (
    state.data.facts.nuts3 &&
    state.data.toJoin.employment_data
    ) {

    hydrated = true;
    hydratedQuery = alaSQL(`
            SELECT * FROM ? as nuts3
            LEFT JOIN ? AS employment_data ON nuts3.id = employment_data.id
            `,
      [
        state.data.facts.nuts3,
        state.data.toJoin.employment_data
      ]);

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'employment_data': hydratedQuery
    }

    //Empty geoJSON shapes
    const geojsonShapes = {
      name: "employment-shapes",
      type: "FeatureCollection",
      features: []
    };

    // Fill geoJSON files
    let geometry, properties;
    hydratedQuery.forEach(d => {
      //Parse shape & point
      try {
        if(d.geometry){
          geometry = wellknown.parse(d.geometry);
        } else {
          geometry = false;
        }
      } catch (error) {
        console.error('ERROR wellknown.parse',error);
      }

      //Copy & remove geo properties
      properties = getPropertiesNUTS3Object(d,'europe');

      //Fill shapes geojson
      if (geometry){
        geojsonShapes.features.push({
          type: "Feature",
          geometry,
          properties
        });
      }

    });

    //Add to geojsons options
    state.map.geojsonOptions[VIEWS.EMPLOYMENT] = geojsonShapes;

    //Remove from toJoin
    delete state.data.toJoin.employment_data;
  }

  //occupational_data
  if (
    state.data.facts.nuts3 &&
    state.data.dimensions.isco &&
    state.data.toJoin.occupational_data
  ) {

    const occupationalFields = [
      "employment_absolute_2018_thousands",
      "employment_share_of_region_2018_percent",
      "employment_absolute_2030_thousands",
      "employment_share_of_region_2030_percent",
      "jobs_change_18_30_percent",
      "isco_1_id",
      "isco_1_name",
      "isco_2_name",
      "isco_2_id"
    ];


    const nuts3Fields = [
      "id",
      "name",
      "cluster_id",
      "urban_id",
      "metro_id",
      "metro_name",
      "country_id",
      /*"centroid_x",
      "centroid_y",*/
      "geometry",
      "cluster_name",
      "urban_name",
      "country_name"
    ];

    const rawJoin = alaSQL(`
            SELECT * FROM ? as occupational_data
            LEFT JOIN ? AS nuts3 ON nuts3.id = occupational_data.nuts3_id
            LEFT JOIN ? AS isco ON isco.isco_2_id = occupational_data.isco_2_id
            `,
      [
        state.data.toJoin.occupational_data,
        state.data.facts.nuts3,
        state.data.dimensions.isco
      ]);

    hydrated = true;
    hydratedQuery = alaSQL(`
            SELECT ${buildSQLFirstSelectString(nuts3Fields)} , ARRAY(${buildSQLArrayString(occupationalFields)}) AS items
            FROM ? as joined
            GROUP BY id`,
      [
        rawJoin
      ]);

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'occupational_data': rawJoin
    }

    //Empty geoJSON shapes
    const geojsonShapes = {
      name: "occupational-shapes",
      type: "FeatureCollection",
      features: []
    };

    // Fill geoJSON files
    let geometry, properties;

    hydratedQuery.forEach(d => {
      //Parse shape
      try {
        if (d.geometry) {
          geometry = wellknown.parse(d.geometry);
        } else {
          geometry = false;
        }
      } catch (error) {
        console.error('ERROR wellknown.parse', error);
      }

      //Copy & remove geo properties
      properties = getPropertiesNUTS3Object(d, 'occupations');

      properties.items.forEach(item => {
        occupationalFields.forEach(field => {
          properties[`${item.isco_2_id}_${field}`] = item[field];
        });
      });

      delete properties.items;
      delete properties.geometry;

      //Fill shapes geojson
      if (geometry) {
        geojsonShapes.features.push({
          type: "Feature",
          geometry,
          properties
        });
      }

    });

    //Add to geojsons options
    state.map.geojsonOptions[VIEWS.OCCUPATIONAL] = geojsonShapes;

    //Remove from toJoin
    delete state.data.toJoin.occupational_data;
  }

  //Employment shares top10
  if (
    state.data.facts.nuts3 &&
    state.data.toJoin.occupational_shares
  ) {

    hydrated = true;
    try {
      hydratedQuery = alaSQL(`
              WITH nuts3Join as (SELECT DISTINCT(metro_id) as metro_id, metro_name from ?)
              SELECT * FROM ? as occupational_shares
              LEFT JOIN nuts3Join AS metros ON metros.metro_id = occupational_shares.metro_id
              `,
        [
          state.data.facts.nuts3,
          state.data.toJoin.occupational_shares,
        ]);
    } catch (error) {
      console.error(error);
    }

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'occupational_shares': hydratedQuery
    }

    //Remove from toJoin
    delete state.data.toJoin.occupational_shares;
  }

  //Occupations clusters
  if (
    state.data.dimensions.isco &&
    state.data.dimensions.clusters &&
    state.data.toJoin.occupational_clusters
  ) {

    hydrated = true;
    try {
      hydratedQuery = alaSQL(`
              WITH iscoJoin as (SELECT isco_2_id, isco_2_name from ?),
                   clusterJoin as (SELECT cluster_id, cluster_name from ?)
              SELECT * FROM ? as occupational_clusters
              LEFT JOIN iscoJoin AS iscos ON iscos.isco_2_id = occupational_clusters.isco_2_id
              LEFT JOIN clusterJoin AS clusters ON clusters.cluster_id = occupational_clusters.cluster_id
              `,
        [
          state.data.dimensions.isco,
          state.data.dimensions.clusters,
          state.data.toJoin.occupational_clusters
        ]);
    } catch (error) {
      console.error(error);
    }

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'occupational_clusters': hydratedQuery
    }

    //Remove from toJoin
    delete state.data.toJoin.occupational_clusters;
  }

  //Occupations EU
  if (
    state.data.dimensions.isco &&
    state.data.toJoin.occupational_eu
  ) {

    hydrated = true;
    try {
      hydratedQuery = alaSQL(`
              WITH iscoJoin as (SELECT isco_2_id, isco_2_name from ?)
              SELECT * FROM ? as occupational_eu
              LEFT JOIN iscoJoin AS iscos ON iscos.isco_2_id = occupational_eu.isco_2_id
              `,
        [
          state.data.dimensions.isco,
          state.data.toJoin.occupational_eu
        ]);
    } catch (error) {
      console.error(error);
    }

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'occupational_eu': hydratedQuery
    }

    //Remove from toJoin
    delete state.data.toJoin.occupational_eu;
  }

  //Top Occupations future
  if (
    state.data.dimensions.isco &&
    state.data.toJoin.nuts3_top_occupations_future
  ) {

    hydrated = true;
    try {
      hydratedQuery = alaSQL(`
              WITH iscoJoin as (SELECT isco_2_id, isco_2_name from ?)
              SELECT * FROM ? as top_occupations
              LEFT JOIN iscoJoin AS iscos ON iscos.isco_2_id = top_occupations.isco_2_id
              `,
        [
          state.data.dimensions.isco,
          state.data.toJoin.nuts3_top_occupations_future
        ]);
    } catch (error) {
      console.error(error);
    }

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'nuts3_top_occupations_future': hydratedQuery
    }

    //Remove from toJoin
    delete state.data.toJoin.nuts3_top_occupations_future;
  }

  //
  if (
    state.data.dimensions.clusters &&
    state.data.toJoin.clusters_avg
  ) {

    hydrated = true;
    try {
      hydratedQuery = alaSQL(`
              WITH clusterJoin as (SELECT cluster_id, cluster_name from ?)
              SELECT * FROM ? as clusters_avg
              LEFT JOIN clusterJoin AS clusters ON clusters.cluster_id = clusters_avg.cluster_id
              `,
        [
          state.data.dimensions.clusters,
          state.data.toJoin.clusters_avg
        ]);
    } catch (error) {
      console.error(error);
    }

    //Add in facts
    state.data.facts = {
      ...state.data.facts,
      'clusters_avg': hydratedQuery
    }

    //Remove from toJoin
    delete state.data.toJoin.clusters_avg;
  }


  return {changed:hydrated, state:state};
}

export function updateSearch(key, state) {
  let searchUpdated = false;
  let temp, itemTemp;
  switch (key) {

    //Fill search index with occupations
    case FILE_KEYS.ISCO_REFERENCE:
      searchUpdated = true;

      temp = state.data.dimensions.isco.map(c => {
        return {
          id: c.isco_2_id,
          name: c.isco_2_name,
          type: 'ISCO',
          meta: normalizeString(`${c.isco_1_name} ${c.isco_2_name}`.replace(',',''))
        };
      });

      state.search.options[2].items = temp;

      break;

    //Fill search index with clusters
    case FILE_KEYS.CLUSTERS_REFERENCE:
      searchUpdated = true;

      temp = state.data.dimensions.clusters.map(c => {
        return {
          id: c.cluster_id,
          name: c.cluster_name,
          type: 'Cluster',
          meta: normalizeString(c.cluster_name)
        };
      });

      state.search.default[0].items = temp;
      state.search.options[0].items = temp;

      break;

    //Fill search index with NUTS3
    case FILE_KEYS.NUTS3_SHAPES:
    case FILE_KEYS.NUTS3_PRESENT:
    case FILE_KEYS.URBAN_REFERENCE:
    case FILE_KEYS.METRO_STATS:
    case FILE_KEYS.COUNTRIES_REFERENCE:

      if (state.data.facts.nuts3){

        searchUpdated = true;

        state.search.default[1].items = [];

        temp = state.data.facts.nuts3.map(n => {
          itemTemp = {
            id: n.id,
            name: `${n.name}, ${n.country_name}`,
            lat: n.centroid_y,
            lng: n.centroid_x,
            type: 'Region',
            meta: normalizeString(`${n.name} ${n.name_trans} ${n.metro_name} ${n.metro_name_trans} ${n.country_name}`)
          };
          if (FEATURED_REGIONS.indexOf(itemTemp.id)>-1){
            state.search.default[1].items.push(itemTemp);
          }
          return itemTemp;
        });

        state.search.options[1].items = temp.filter(i => (i.name !== 0));

      }


      break;

    default:
      searchUpdated = false;
      break;
  }
  return {changed: searchUpdated, state: state};
}
